import s from './Item.scss'
import { InputContainer, KeyValuePairs } from 'components/ideal-core-ui'
import { NumericFormat } from 'react-number-format'
import { getCurrency } from 'utils/authService'
import { FaTrashAlt, FaCalculator } from 'react-icons/fa'
import cn from 'classnames'

const Item = ({ item, removeItem, changeProperty, index, itemType, updateItem }) => {
  return (
    <>
      <div
        className={cn(s.item, {
          [s.error]: !item.pristine
        })}
      >
        <FaTrashAlt
          className={cn(s.removeItem, {
            [s.notFirst]: index !== 0
          })}
          onClick={() => removeItem(item.id)}
        />
        <InputContainer
          type="text"
          placeholder="Item Description"
          cb={value => changeProperty(value, 'name', item.id)}
          text={item.name}
          style={{
            width: '200px',
            display: 'initial',
            padding: index === 0 ? '10px 0 0 10px' : '0 0 0 10px'
          }}
          classname={s.input}
        />
        <KeyValuePairs
          style={{
            padding: index === 0 ? '10px 10px 0 10px' : '0 10px 0 10px'
          }}
          pairs={[
            {
              key: itemType?.type === 'quantity' ? 'Quantity' : 'Hours',
              keyClass: [s.label],
              valueClass: [s.value],
              value: (
                <InputContainer
                  type="text"
                  placeholder="Hours"
                  cb={value => changeProperty(value, 'value', item.id)}
                  text={item.value}
                  classname={s.input}
                />
              )
            }
          ]}
        />
        <KeyValuePairs
          style={{
            padding: index === 0 ? '10px 10px 0 10px' : '0 10px 0 10px'
          }}
          pairs={[
            {
              key: itemType?.type === 'quantity' ? 'Price/unit' : 'Price/hr',
              keyClass: [s.label],
              valueClass: [s.value],
              value: (
                <>
                  <NumericFormat
                    thousandSeparator
                    placeholder={itemType?.type === 'quantity' ? 'Price/unit' : 'Price/hr'}
                    decimalScale={2}
                    allowNegative={false}
                    value={item.price}
                    prefix={getCurrency().symbol}
                    onValueChange={formattedValue => {
                      changeProperty(formattedValue.floatValue, 'price', item.id)
                    }}
                    style={{
                      padding: '0 5px',
                      position: 'relative',
                      top: 8,
                      left: 20,
                      width: 100
                    }}
                  />
                  <FaCalculator
                    className={s.saveItem}
                    onClick={() => updateItem(item.id, itemType.value)}
                  />
                </>
              )
            }
          ]}
        />
        <KeyValuePairs
          style={{
            padding: index === 0 ? '10px 10px 0 10px' : '0 10px 0 10px'
          }}
          pairs={[
            {
              key: 'Total Item',
              keyClass: [s.totalLabel],
              valueClass: [s.totalValue],
              value: (
                <NumericFormat
                  thousandSeparator
                  placeholder="Total Item"
                  decimalScale={2}
                  value={item.totalItemValue}
                  prefix={getCurrency().symbol}
                  style={{
                    position: 'relative',
                    left: 5,
                    top: 8,
                    padding: '4px 0px',
                    width: 110,
                    display: 'inline-block'
                  }}
                  displayType={'text'}
                />
              )
            }
          ]}
        />
      </div>
    </>
  )
}

export default Item
